module.exports = __webpack_public_path__ + "img/stats_mobile@2x.06b161c.webp";